module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app bg-gray"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('form', {
    staticClass: "gwi-form",
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm($event)
      }
    }
  }, [_c('section', [_c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "ipt-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    staticClass: "form-right gwi-ipt my-ipt",
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "ipt-item"
  }, [_c('TypeSelect', {
    attrs: {
      "labelName": "证件类型",
      "typeList": _vm.cardTypeList
    },
    on: {
      "type-select": _vm.selectCardType
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "ipt-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cardNo),
      expression: "cardNo"
    }],
    staticClass: "form-right gwi-ipt my-ipt",
    attrs: {
      "type": "text",
      "placeholder": "请输入证件号码",
      "maxlength": "18"
    },
    domProps: {
      "value": (_vm.cardNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cardNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "ipt-item"
  }, [_c('TypeSelect', {
    attrs: {
      "labelName": "性别",
      "typeList": _vm.sexList
    },
    on: {
      "type-select": _vm.selectSex
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "ipt-item"
  }, [_c('TypeSelect', {
    attrs: {
      "labelName": "国籍",
      "typeList": _vm.nationalityList
    },
    on: {
      "type-select": _vm.selectNationality
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "ipt-item"
  }, [_c('TypeSelect', {
    attrs: {
      "labelName": "民族",
      "typeList": _vm.nationList
    },
    on: {
      "type-select": _vm.selectNation
    }
  })], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSelectCardType.key !== '01'),
      expression: "currentSelectCardType.key !== '01'"
    }],
    staticClass: "my-ipt-item"
  }, [_c('div', {
    staticClass: "time"
  }, [_c('div', {
    staticClass: "time-title"
  }, [_vm._v("出生日期")]), _vm._v(" "), _c('div', {
    staticClass: "time-option",
    on: {
      "click": _vm.setBirthday
    }
  }, [_vm._v("\n                " + _vm._s(_vm.birthday) + "\n              ")])])]), _vm._v(" "), _c('li', {
    staticClass: "ipt-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-right gwi-ipt my-ipt",
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号码",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "ipt-item"
  }, [_c('TypeSelect', {
    attrs: {
      "labelName": "婚姻状况",
      "typeList": _vm.marriageList
    },
    on: {
      "type-select": _vm.selectMarriage
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "ipt-item"
  }, [_c('TypeSelect', {
    attrs: {
      "labelName": "职业",
      "typeList": _vm.occupationList
    },
    on: {
      "type-select": _vm.selectOccupation
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "ipt-item"
  }, [_c('AddressSelect', {
    attrs: {
      "labelName": "地址选择",
      "select": _vm.select
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "ipt-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail),
      expression: "detail"
    }],
    staticClass: "form-right gwi-ipt my-ipt",
    attrs: {
      "type": "text",
      "placeholder": "请输入详细地址",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detail = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "voucher-add-footer box"
  }, [_c('button', {
    staticClass: "btn-ok",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("\n          申请电子健康卡\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-tips"
  }, [_c('p', {
    staticClass: "f-strongest"
  }, [_vm._v("请务必填写真实的身份信息，否则可能无法就诊")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-579b0c4a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/voucher/VoucherRegister.vue
// module id = 836
// module chunks = 0